import {
  Alert,
  AlertIcon,
  Flex,
  HStack,
  IconButton,
  Link,
  Stack,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { observer } from "mobx-react";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { PrimayButton } from "../../components/Button";
import { EvaluationCard } from "../../components/EvaluationCard";
import { EvaluationModal } from "../../components/EvaluationModal";
import { Icon } from "../../components/Icon";
import { useStores } from "../../hooks/useStores";
import { Evaluation } from "../../types";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";

export const ClientEvaluations: React.FC = observer(() => {
  const { session, clientsStore } = useStores();
  const { t } = useTranslation();
  const history = useHistory();
  const [evaluation, setEvaluation] = useState<Evaluation | null>(null);
  const {
    isOpen: isModalOpen,
    onOpen: onModalOpen,
    onClose: onModalClose,
  } = useDisclosure();

  // useEffect(() => {
  //   ReactGA.pageview("/client/evaluations");
  // }, []);

  useEffect(() => {
    if (session.user?.id) {
      clientsStore.getEvaluation(session.user?.id);
    }
    clientsStore.getPersonalObjective(session.user?.id as string);
    clientsStore.getGenericObjective(session.user?.id as string);
  }, [clientsStore, session.user]);

  const handleSubmit = useCallback(
    async (data: any) => {
      try {
        if (session.user) {
          if (evaluation) {
            await clientsStore.updateEvaluation(data);
          } else {
            await clientsStore.addEvaluation(session.user.id, data);

            ReactGA.event({
              category: "Customer",
              action: "Valutazione Risultati Mensile",
            });
            ReactPixel.track("Valutazione Risultati Mensile");
          }
        }

        onModalClose();
        setEvaluation(null);
      } catch (err) {
        console.log(err);
      }
    },
    [session.user, onModalClose, evaluation, clientsStore]
  );

  const handleDelete = useCallback(
    async (data: any) => {
      try {
        if (data) {
          //DELETE
          await clientsStore.deleteEvaluation(data);
        }
      } catch (err) {
        console.log(err);
      }
    },
    [clientsStore, t]
  );

  return (
    <Stack margin={"2rem"} gridGap={"2rem"}>
      <HStack marginBottom={"2rem"}>
        <IconButton
          aria-label="Back"
          icon={<Icon iconName={"HiArrowLeft"} />}
          variant={"ghost"}
          onClick={() => history.push("/client/board")}
        />
        <Stack>
          <Text fontSize="3xl">Valutazioni</Text>
        </Stack>
      </HStack>

      <Flex flexFlow="row-reverse">
        <PrimayButton
          onClick={onModalOpen}
          disabled={
            session.isSubscriptionDeactivated ||
            !clientsStore.personalObjective ||
            clientsStore.genericObjectives.length === 0
          }
        >
          {t("screens.client.evaluation.btnNew")}
        </PrimayButton>
      </Flex>

      {(!clientsStore.personalObjective ||
        clientsStore.genericObjectives.length === 0) && (
        <Alert status="warning">
          <AlertIcon />
          <Text>
            Prima di inserire una valutazione, devi completare la sezione{" "}
            <Link
              href="/#/client/objectives"
              marginLeft="0.5rem"
              color="purple"
            >
              Obiettivi e Fattore X!
            </Link>
          </Text>
        </Alert>
      )}

      {clientsStore.evaluation?.map((item, index) => {
        return (
          <EvaluationCard
            onEdit={() => {
              setEvaluation(item);
              onModalOpen();
            }}
            dateOnTop={false}
            evaluation={item}
            onDelete={() => {
              handleDelete(item);
            }}
            prevEvaluationIndex={index + 1}
            isSubscriptionDeactivated={session.isSubscriptionDeactivated}
          />
        );
      })}

      <EvaluationModal
        isOpen={isModalOpen}
        evaluation={evaluation}
        onClose={() => {
          onModalClose();
          setEvaluation(null);
        }}
        onSubmit={handleSubmit}
      />
    </Stack>
  );
});
